import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, UserDataOut, UserStatus } from '../../../../api/api-reference';

@Component({
  selector: 'app-member-information',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './member-information.component.html',
  styleUrl: './member-information.component.scss',
})
export class MemberInformationComponent implements OnInit {
  @Input() memberId: string = '';
  @Output() close = new EventEmitter<boolean>();
  member: UserDataOut = new UserDataOut();
  backgroundColors: string[] = [];
  RoleStatus = UserStatus;

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  predefinedColors: string[] = [
    'rgba(203, 195, 8, 1)',
    'rgba(32, 143, 223, 1)',
    'rgb(203 8 8)',
    'rgba(38, 196, 120, 1)',
    'rgba(235, 160, 48, 1)',
    'rgba(229, 114, 89, 1)',
    'rgba(144, 75, 231, 1)',
    'rgb(8 59 203)',
    'rgb(164 8 203)',
    'rgb(203 8 143)',
    'rgb(203 80 8)',
    'rgb(173 203 8)',
    'rgb(203 98 8)',
    'rgb(8, 59, 203)',
    'rgb(146 203 8)',
  ];

  ngOnInit(): void {
    this.getMemberById();
  }

  toggleModal() {
    this.close.emit();
  }

  getMemberById() {
    this.client.getUser(this.memberId).subscribe({
      next: (response) => {
        this.member = response;

        this.backgroundColors = this.predefinedColors.slice(
          0,
          this.member.areaNames!.length,
        );
      },
      error: (err) => {
        this.toastr.success(err);
      },
    });
  }
}
